module.exports = __webpack_public_path__ + "static/media/auth-ov.1a86659e.png";